export default __webpack_public_path__ + "static/media/objet.18ab55ae.svg";